import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.css';



export default class HeaderButton extends Component {

    render() {
        return (
        <div
            className="hsg-header-btn-root left" 
            onClick={() => {this.props.onClick()}}>

            <div className={"hsg-header-btn-icon" + (this.props.selected ? " hsg-header-btn-icon-selected" : "")}>
                <i className={this.props.glyph} />
            </div>


            <p className={"hsg-header-btn-text" + (this.props.selected ? " hsg-header-btn-text-selected" : "")}>
                {this.props.text}
            </p>


            {this.props.selected && <div className="hsg-header-btn-underline"></div>}

        </div>);
    }

}



HeaderButton.propTypes = {
    text: PropTypes.string.isRequired,
    glyph: PropTypes.string.isRequired,
    selected: PropTypes.bool,

    onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/Components/HeaderButton/index.js